import { types } from '../actions/types';

const DEFAULT_STATE = {
    authData: {
        id: null,
        email: null
    },
    uid: null,
    serverError: null,
    passwordData: null,
    companyData: null,
    isAuthFlow: null,
    verificationStatus: null,
    signinTokenIsValid: false,
    isActivationFlowFinished: false,
    isValidActivationCode: false,
    activationFormSubmitted: false
}

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {

        case types.LOG_IN_SUCCESS:
            return {
                ...state, uid: action.uid
            }
        case types.CLEAR_USER_DATA:
            return {
                ...DEFAULT_STATE
            }
        case types.EMAIL_VERIFIED:
            // console.log('Receiving new verification... @Reducer');
            return {
                    ...state, verificationStatus: action.payload
                }
        case types.LOG_IN_FAIL:
            return {
                ...state, serverError: action.payload
            }
        case types.SIGN_UP_FAIL:
            return {
                ...state, serverError: action.payload
            };
            break;
        case types.CLEAR_SERVER_ERROR:
            return {
                ...state, serverError: action.payload
            }
            break;
        case types.LOG_OUT_SUCCESS:
            return {
                ...DEFAULT_STATE
            };
        case types.FETCH_AUTH_DATA_SUCCESS:
            return {
                ...state, authData: {
                    id: action.payload.uid, // @TODO: to be phased out(uid is best naming)
                    uid: action.payload.uid,
                    email: action.payload.email,
                    emailVerified: action.payload.emailVerified,
                }
            };
        case types.REGISTER_COMPANY_DATA_SUCCESS:
            return {
                ...state, companyData: action.payload
            };
        case types.PASSWORD_STRENGTH_SCORE:
            return {
                ...state, passwordData: action.payload
            };
        case types.AUTH_FLOW_IN_PROCESS:
            return {
                ...state, isAuthFlow: action.payload
            };
        case types.SET_LOGIN_DIALOG_OPEN:
            return {
                ...state, loginDialogOpen: action.payload
            };
        case types.SET_LOGIN_DIALOG_CLOSED:
            return {
                ...state, loginDialogOpen: action.payload
            };
        case types.TOKEN_SIGNIN:
            return {
                ...state, authData: {
                    id: action.payload.user.uid,
                    uid: action.payload.user.uid,
                    email: action.payload.user.email,
                    emailVerified: action.payload.user.emailVerified,
                },
                signinTokenIsValid: true,
                // verificationStatus: true,
                uid: action.payload.user.uid
            };
            break;
        case types.ACCOUNT_ACTIVATION_SUCCESS:
            return {
                ...state,
                isActivationFlowFinished: action.payload,
                signinTokenIsValid: !action.payload,
                isValidActivationCode: !action.payload
            }
            break;
        case types.VALID_ACTIVATION_CODE:
            return {
                ...state, isValidActivationCode: true
            }
            break;
        case types.ACTIVATION_FORM_SUCCESS:
            return {
                ...state, activationFormSubmitted: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/auth-reducer.js